export function getVersion(language) {
  let version;
  currentVersion.map((ver)=>{
    if (!version && ver.locale === language) {
      version = ver;
    }
  });

  return version;
}

export const currentVersion = [
  {
    locale: 'EN',
    version: '1.0.0',
    date: '2018-08-20',
    description: '',
    updates: [
      {
        title: 'Navigation Style Update',
        description: '',
      },
      {
        title: '',
        description: '',
      },
    ],
  },
  {
    locale: 'CN',
    version: '1.0.0',
    date: '2018-08-20',
    description: '',
    updates: [
      {
        title: 'Navigation Style Update',
        description: '',
      },
      {
        title: '',
        description: '',
      },
    ],
  },

]



// WEBPACK FOOTER //
// ./src/version.js